import Vue from "vue";
import Vuex from "vuex";
import Vue2TouchEvents from "vue2-touch-events";
import VueObserveVisibility from "vue-observe-visibility";
import WayfinderVueComponents from "@3dwayfinder/wayfinder-vue-components";
import { loadWayfinder } from '@3dwayfinder/wayfinder-vue-components';


import App from "./App.vue";
import "./registerServiceWorker";
import "./css/index.css";
import { SCHENGEN_ZONE } from "@/types/Template";

Vue.use(Vuex);
Vue.use(VueObserveVisibility);
Vue.use(Vue2TouchEvents, { tapTolerance: 20 });

Vue.config.productionTip = false;

let WF_MAP_TYPE = "3d";
//const WF_API = "dev";
const WF_API = "enterprise";
let WF_PROJECT = "8aac0a8fcdaf1f3e720b6b0d89775a00";

if (WF_API == "enterprise") {
  WF_PROJECT = "main";
}

const store = new Vuex.Store({
  state: {
    appName: "Wayfinder Vue Components",
    currentPOI: null,
    accessible: false,
    flights: { arrivals: [], departures: [] },
    currentGroup: null,
    defaultGroup: null,
    searchVisible: false,
    schengenZone: SCHENGEN_ZONE,
    flightDirection: "departures",
    currentTab: "groups",
    currentPage: "grouppois",
    mainTabResetKey: 0,
    activities: [],
    directionsOpened: false,
  },
  mutations: {
    setPOI(state, poi) {
      state.currentPOI = poi;
    },
    setDirectionsOpened(state, bool) {
      state.directionsOpened = bool;
    },
    setCurrentPage(state, page) {
      state.currentPage = page;
    },
    resetMainTab(state) {
      state.mainTabResetKey += 1;
    },
    setAccessible(state, bool) {
      state.accessible = bool;
    },
    setSchengenZone(state, zone) {
      state.schengenZone = zone;
    },
    setFlightDirection(state, direction) {
      state.flightDirection = direction;
    },
    setFlights(state, flights) {
      state.flights = flights;
    },
    setGroup(state, group) {
      state.currentGroup = group;
    },
    setDefaultGroup(state, group) {
      state.defaultGroup = group;
    },
    showSearch(state, show) {
      state.searchVisible = show;
    },
    setTab(state, tab) {
      state.currentTab = tab;
    },
    activities(state, activities) {
      state.activities = activities;
    },
  },
  actions: {
    setPOI: (context, poi) => {
      context.commit("setPOI", Object.freeze(poi));
    },
    setDirectionsOpened: (context, bool) => {
      context.commit("setDirectionsOpened", bool);
    },
    setFlights: (context, flights) => {
      context.commit("setFlights", Object.freeze(flights));
    },
    setCurrentPage: (context, page) => {
      context.commit("setCurrentPage", Object.freeze(page));
    },
    resetMainTab: (context) => {
      context.commit("resetMainTab");
    },
    setAccessible: (context, bool) => {
      context.commit("setAccessible", Object.freeze(bool));
    },
    setSchengenZone: (context, zone) => {
      context.commit("setSchengenZone", Object.freeze(zone));
    },
    setFlightDirection: (context, direction) => {
      context.commit("setFlightDirection", Object.freeze(direction));
    },
    setGroup: (context, group) => {
      context.commit("setGroup", Object.freeze(group));
    },
    setDefaultGroup: (context, group) => {
      context.commit("setDefaultGroup", Object.freeze(group));
    },
    showSearch: (context, show) => {
      console.log("show", show);
      console.trace();
      context.commit("showSearch", show);
    },
    setTab: (context, show) => {
      context.commit("setTab", show);
    },
  },
});

loadWayfinder(WF_MAP_TYPE, WF_API, loadVue);

function loadVue () {
	new Vue({
		store,
		render: h => h(App),
		created () {
			Vue.use(WayfinderVueComponents, this.$store, WF_MAP_TYPE, WF_PROJECT, WF_API)
		}
	}).$mount('#app')
}
